/** Book-level chapter audio voice preferences (stored in `book.metadata.audioSettings`). */

export type BookAudioSettings = {
  /**
   * Voice ids chosen for this book.
   * - Empty / missing: use the first available provider voice as a single default.
   * - One id: that voice is used for every chapter (no chapter dropdown).
   * - Multiple ids: multi-POV — chapter bar shows a voice dropdown.
   */
  voiceIds: string[];
};

export const CHAPTER_AUDIO_VOICE_FIELD = "audioVoiceId";

export function normalizeBookAudioSettings(raw: unknown): BookAudioSettings {
  if (!raw || typeof raw !== "object") return { voiceIds: [] };
  const voiceIds = (raw as { voiceIds?: unknown }).voiceIds;
  if (!Array.isArray(voiceIds)) return { voiceIds: [] };
  const cleaned = voiceIds
    .filter((id): id is string => typeof id === "string" && id.trim().length > 0)
    .map((id) => id.trim());
  return { voiceIds: Array.from(new Set(cleaned)) };
}

export function readBookAudioSettings(metadata: Record<string, unknown> | undefined | null): BookAudioSettings {
  return normalizeBookAudioSettings(metadata?.audioSettings);
}

export function readChapterAudioVoiceId(
  customFields: Record<string, unknown> | undefined | null
): string | null {
  const raw = customFields?.[CHAPTER_AUDIO_VOICE_FIELD];
  return typeof raw === "string" && raw.trim() ? raw.trim() : null;
}
